import { atom } from "jotai";

export const suggestionsState = atom([]);